const exerciseRoutes = {
  exercises: { path: '/exercises' },
  exercisesPlay: { path: '/exercises/play' },
  createExercise: { path: '/exercises/create' },
  editExercise: { path: '/exercises/:id/edit' },
  exerciseRequests: { path: '/exercises/requests' }
};

export default exerciseRoutes;
